import { render, staticRenderFns } from "./QuoteCarousel.vue?vue&type=template&id=083eadba&scoped=true"
import script from "./QuoteCarousel.vue?vue&type=script&lang=js"
export * from "./QuoteCarousel.vue?vue&type=script&lang=js"
import style0 from "./QuoteCarousel.vue?vue&type=style&index=0&id=083eadba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083eadba",
  null
  
)

export default component.exports